import React from 'react';
import PropTypes from 'prop-types';
import { Card as AntCard } from 'antd';
import Card from '../../../core/layout/Card';
import Table from '../../../core/form/Table';
import Tag from '../../../core/layout/Tag';
import { isNumber, head, has, get } from 'lodash';
import TooltipIcon from '../../../core/layout/TooltipIcon';

const { Meta } = AntCard;

const KpiTable = (props) => {
  return (
    <Card title={props.title} loading={props.loading}>
      <Meta description={props.description} />
      <div
        style={{
          margin: '30px 0',
          display: 'block',
        }}
      >
        <Table
          showTableCount={false}
          rows={props.values}
          columns={[
            {
              label: props.nameColumnLabel,
              path: props.nameColumnPath,
              sort: (a, b) => {
                const aValue = props.nameColumnRender ? props.nameColumnRender(a) : get(a, props.nameColumnPath, '');
                const bValue = props.nameColumnRender ? props.nameColumnRender(b) : get(b, props.nameColumnPath, '');
                return aValue.localeCompare(bValue, undefined, { numeric: true, sensitivity: 'base' });
              },
              render: (text, record) => {
                return {
                  children: props.nameColumnRender ? props.nameColumnRender(record) : text,
                };
              },
            },
            {
              label: props.firstDataColumnLabel,
              path: props.firstDataColumnPath,
              sort: true,
              defaultSortOrder: 'descend',
              render: (value) =>
                props.feedbackColorRender && isNumber(value) ? (
                  <Tag color={props.feedbackColorRender(value)}>{props.formatter(value)}</Tag>
                ) : (
                  props.formatter(value)
                ),
            },
            ...(has(head(props.values), props.secondDataColumnPath)
              ? [
                  {
                    label: () =>
                      props.secondDataColumnTooltip ? (
                        <>
                          <span>{props.secondDataColumnLabel}</span>
                          <TooltipIcon text={props.secondDataColumnTooltip} />
                        </>
                      ) : (
                        props.secondDataColumnLabel
                      ),
                    path: props.secondDataColumnPath,
                    sort: true,
                    render: (value) =>
                      props.feedbackColorRender && isNumber(value) ? (
                        <Tag color={props.feedbackColorRender(value)}>{props.formatter(value)}</Tag>
                      ) : (
                        props.formatter(value)
                      ),
                  },
                ]
              : []),
            ...props.additionalColumns,
          ]}
          onSelect={props.onSelect}
          selectable
        />
      </div>
    </Card>
  );
};

KpiTable.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  onSelect: PropTypes.func,
  currentHigherIsBetter: PropTypes.bool,
  formatter: PropTypes.func,
  feedbackColorRender: PropTypes.func,
  nameColumnRender: PropTypes.func,
  nameColumnPath: PropTypes.string,
  nameColumnLabel: PropTypes.string,
  firstDataColumnLabel: PropTypes.string,
  firstDataColumnPath: PropTypes.string,
  secondDataColumnLabel: PropTypes.string,
  secondDataColumnPath: PropTypes.string,
  secondDataColumnTooltip: PropTypes.string,
  additionalColumns: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      sort: PropTypes.bool.isRequired,
      render: PropTypes.func,
    })
  ),
};

KpiTable.defaultProps = {
  title: null,
  description: null,
  currentHigherIsBetter: true,
  formatter: (value) => value,
  onSelect: () => false,
  nameColumnRender: null,
  nameColumnPath: 'name',
  additionalColumns: [],
  nameColumnLabel: '',
  firstDataColumnLabel: 'Current',
  firstDataColumnPath: 'current',
  secondDataColumnLabel: 'Previous',
  secondDataColumnPath: 'previous',
  secondDataColumnTooltip: null,
};

export default KpiTable;
